import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

declare global {
  interface Window {
    MercadoPago?: any;
  }
}

/**
 * Carga perezosa del SDK v2 de Mercado Pago y creación de la instancia para
 * Checkout Bricks. La Public Key es pública por diseño (va en el frontend).
 * Ver SPEC-016.
 */
@Injectable({ providedIn: 'root' })
export class MercadoPagoSdkService {
  private loading?: Promise<any>;
  private mp?: any;

  /** Devuelve una instancia MercadoPago inicializada (carga el script si hace falta). */
  load(): Promise<any> {
    if (this.mp) return Promise.resolve(this.mp);
    if (this.loading) return this.loading;

    this.loading = new Promise((resolve, reject) => {
      if (!environment.mpPublicKey) {
        reject(new Error('Falta configurar mpPublicKey (Public Key de Mercado Pago).'));
        return;
      }
      const init = () => {
        try {
          this.mp = new window.MercadoPago(environment.mpPublicKey, { locale: 'es-PE' });
          resolve(this.mp);
        } catch (e) {
          reject(e);
        }
      };
      if (window.MercadoPago) {
        init();
        return;
      }
      const s = document.createElement('script');
      s.src = 'https://sdk.mercadopago.com/js/v2';
      s.async = true;
      s.onload = init;
      s.onerror = () => reject(new Error('No se pudo cargar el SDK de Mercado Pago.'));
      document.head.appendChild(s);
    });
    return this.loading;
  }
}
